<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Observation Questions</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
    </div>
    <div class="ttmodal__body">
        <mat-list *ngFor="let list of ObservationPoint.ObservationListQuestions">
            <h3 mat-subheader>{{list.ListDesc}}</h3>
            <mat-selection-list>
                <mat-list-option  [selected]='question.Checked'  [value]='question.Id'
                name='question.QuestionDesc' *ngFor="let question of list.Questions"
                (click)="Checked(question)"  ngDefaultControl>

                    <span matLine>
                      {{question.QuestionDesc}}
                      <!-- <photos-modal   style="float: right !important;" [comingFrom]="photoModelEntryPoint" [question]='question' ></photos-modal>
                      <span *ngFor="let img of question.Images"  style="float: right !important;">
                          <img class="question-image__photo" *ngIf="img.Image !== ''" [src]="getImage(img.Image)" />
                      </span> -->
                    </span>

                </mat-list-option>
              </mat-selection-list>
            <mat-divider></mat-divider>
          </mat-list>
    </div>
    <div class="ttmodal__footer">
        <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" [class.loading]="savingChanges" (click)="saveChanges()"><span class="button__text">Save</span></a>
    </div>
</div>
